import { render } from "./customizeMultiSubOption.vue?vue&type=template&id=864ca04a&scoped=true"
import script from "./customizeMultiSubOption.vue?vue&type=script&lang=js"
export * from "./customizeMultiSubOption.vue?vue&type=script&lang=js"

import "./customizeMultiSubOption.vue?vue&type=style&index=0&id=864ca04a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864ca04a"]])

export default __exports__